export default import.meta.ROLLDOWN_FILE_URL_6HXWVMx1N5zM4qBF8KUwkw